import {
  FETCH_CUSTOMER_BEGIN,
  FETCH_CUSTOMER_SUCCESS,
  FETCH_CUSTOMER_FAILURE,
  CURRENT_DISCOUNTCODE,
  CURRENT_GIFTCARD,
  FETCH_CUSTOMERGIFTCARD_BEGIN,
  FETCH_CUSTOMERGIFTCARD_SUCCESS,
  FETCH_CUSTOMERGIFTCARD_FAILURE,
  CURRENT_CHARITY_DONATE,
} from "./constants/constants";

import { base_url } from "../api/api";

export const fetchCustomer = (customerId, shopDomain) => {
  return (dispatch) => {
    dispatch(fetchCustomerBegin());
    base_url
      .get(`/points/${customerId}?shopDomain=${shopDomain}`)
      .then((response) => {
        dispatch(fetchCustomerSuccess(response.data.customer));
      })
      .catch((err) => {
        const errMsg = err.message;
        console.log(errMsg);
        dispatch(fetchCustomerFailure(errMsg));
      });
  };
};

const fetchCustomerBegin = () => ({
  type: FETCH_CUSTOMER_BEGIN,
});

const fetchCustomerSuccess = (customer) => ({
  type: FETCH_CUSTOMER_SUCCESS,
  payload: customer,
});

const fetchCustomerFailure = (error) => ({
  type: FETCH_CUSTOMER_FAILURE,
  payload: error,
});

export const fetchCustomerGiftcards = (customerId, shopDomain) => {
  return (dispatch) => {
    dispatch(fetchCustomerGiftcardsBegin());
    base_url
      .get(`/get/giftcards/${customerId}?shopDomain=${shopDomain}`)
      .then((response) => {
        // console.log(response.data.giftcards);
        dispatch(fetchCustomerGiftcardsSuccess(response.data.giftcards));
      })
      .catch((err) => {
        const errMsg = err.message;
        console.log(errMsg);
        dispatch(fetchCustomerGiftcardsFailure(errMsg));
      });
  };
};

const fetchCustomerGiftcardsBegin = () => ({
  type: FETCH_CUSTOMERGIFTCARD_BEGIN,
});

const fetchCustomerGiftcardsSuccess = (giftcard) => ({
  type: FETCH_CUSTOMERGIFTCARD_SUCCESS,
  payload: giftcard,
});

const fetchCustomerGiftcardsFailure = (error) => ({
  type: FETCH_CUSTOMERGIFTCARD_FAILURE,
  payload: error,
});

export const setCurrentDiscountCode = (discountcode) => ({
  type: CURRENT_DISCOUNTCODE,
  payload: discountcode,
});

export const setCurrentGiftcard = (giftcard) => ({
  type: CURRENT_GIFTCARD,
  payload: giftcard,
});

export const setCurrentCharityDonate = (charity) => ({
  type: CURRENT_CHARITY_DONATE,
  payload: charity,
});
